import { Button } from "@/components/ui/button";
import { Rocket, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function WaitlistScreen() {
  const { signOut } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm text-center space-y-6">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
          <Rocket className="h-10 w-10 text-primary" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">You're on the List!</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Thanks for signing up! Due to high demand, we're granting access in batches to ensure the best experience for everyone. Your spot is secured — we'll notify you by email as soon as it's your turn. Hang tight!
          </p>
        </div>

        <Button variant="outline" onClick={() => signOut()} className="gap-2">
          <LogOut className="h-4 w-4" />
          Sign Out
        </Button>
      </div>
    </div>
  );
}
